/**
 * Whether the convergent charge export applies here, and therefore whether a PMS unit mapping has
 * anywhere to go at all.
 *
 * Mirrors the gate on the export button itself (`NewBillingModule/billing.jsx`): the account flag,
 * then the company/property billing mode. `isAppfolio` is the AppFolio *integration*, not the PMS
 * name — those companies push charges through the integration and never touch the CSV, so the
 * mapping would be dead data for them.
 *
 * @param {object} store the root store.
 * @param {object|null} propertyDashboard the property's dashboard entry, when one is in scope; its
 *   override beats the company setting. Null falls back to the company setting.
 */
export const isConvergentExportEnabled = function (store) {
  var _propertyDashboard$co;
  let propertyDashboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Boolean(store.account.featureFlagsStore.getIsConvergentBillingEnabled && !store.company.companyFeatureStore.isAppfolio && ((_propertyDashboard$co = propertyDashboard === null || propertyDashboard === void 0 ? void 0 : propertyDashboard.convergentBillingModeOverride) !== null && _propertyDashboard$co !== void 0 ? _propertyDashboard$co : store.company.companyFeatureStore.convergentBillingMode));
};